<template>
  <section>
    <h1>Sorry, we can't show you the page you want</h1>
    <h2>You do not have permission to access this page.</h2>
    <p>Tell us what happened. Our friendly team will be happy to help you.</p>
    <p><a class="button" role="button" href="/support/contact-us" title="Contact Us">Contact us</a></p>
    <p>We’re sorry for the inconvenience and appreciate your patience.</p>
  </section>
</template>

<style lang="scss" scoped>
@import '@general/styles/_constants.scss';
@import '@general/styles/_responsive_mixins.scss';
@import '@general/styles/components/_error.scss';
</style>
